module.exports = __webpack_public_path__ + "img/防伪.2aff9327.png";